import type { SxProps, Theme } from '@mui/material';

/** Glassmorphism effect presets */
export const glass = {
  /** Subtle glass for cards */
  card: {
    background: 'rgba(255, 255, 255, 0.72)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
  },
  /** Frosted glass for navigation bar */
  navbar: {
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(221, 221, 221, 0.4)',
  },
  /** Frosted glass for sidebar */
  sidebar: {
    background: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    borderRight: '1px solid rgba(221, 221, 221, 0.3)',
  },
  /** Glass for modal/dialog overlays */
  modal: {
    background: 'rgba(255, 255, 255, 0.88)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    border: '1px solid rgba(255, 255, 255, 0.4)',
  },
} as const;

/** Utility to create glass sx prop */
export const glassSx = (variant: keyof typeof glass): SxProps<Theme> => ({
  ...glass[variant],
});
